var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar-wrapper"},[_c('span',{staticClass:"progress-bar",style:({ width: _vm.adjustableProgress + '%', backgroundColor: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }